import clsx from "clsx";
import { LOGO_HEIGHT, LogoIcon, LogoPurpleIcon, LOGO_WIDTH } from "./Logo.styles";
import { useColor } from "@commonlibs";
import ConditionalLink from "ui/router/components/ConditionalLink/ConditionalLink";
import { LogoProps } from "./Logo.types";

export default function Logo({
    size = "md",
    link = "",
    className,
    color: colorProp = "primary",
    variant = "white",
    ...rest
}: LogoProps): JSX.Element {
    const height = LOGO_HEIGHT[size];
    const width = LOGO_WIDTH[size];
    const color = useColor(colorProp);

    return (
        <ConditionalLink condition={Boolean(link)} to={link || ""} className={clsx("logo", className)} {...rest}>
            {variant === "white" && <LogoIcon className="logo-icon" height={height} width={width} color={color} />}
            {variant === "purple" && <LogoPurpleIcon className="logo-icon" height={height} width={width} color={color} />}
        </ConditionalLink>
    );
}
